import { getApiBaseUrl } from './apiBaseUrl';

const KIOSK_UUID_KEY = 'kiosk_id';
const COORDS_KEY = 'kiosk_coordinates';
const CITY_KEY = 'kiosk_city';
const AREA_KEY = 'kiosk_area';

const getOrCreateKioskUuid = () => {
    let uuid = localStorage.getItem(KIOSK_UUID_KEY);
    if (!uuid) {
        uuid = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
            ? crypto.randomUUID()
            : `ksk-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        localStorage.setItem(KIOSK_UUID_KEY, uuid);
    }
    return uuid;
};

const reverseGeocode = async (lat, lng) => {
    try {
        const res = await fetch(
            `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`,
            { headers: { 'Accept-Language': 'en' } }
        );
        const geo = await res.json();
        const addr = geo?.address || {};
        return {
            city: addr.city || addr.town || addr.village || addr.county || '',
            area: addr.suburb || addr.neighbourhood || addr.road || ''
        };
    } catch (_) {
        return { city: '', area: '' };
    }
};

const sendPing = (payload) => {
    fetch(`${getApiBaseUrl()}/api/kiosk/ping`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...payload, sentAt: new Date().toISOString() }),
        keepalive: true
    })
        .then(r => r.json())
        .then(data => {
            if (data?.kioskUuid) localStorage.setItem(KIOSK_UUID_KEY, data.kioskUuid);
        })
        .catch(() => {});
};

export const initKiosk = () => {
    if (!navigator.geolocation) return;
    navigator.geolocation.getCurrentPosition(
        async (pos) => {
            const { latitude, longitude } = pos.coords;
            const coordinates = `${latitude},${longitude}`;
            localStorage.setItem(COORDS_KEY, coordinates);

            const { city, area } = await reverseGeocode(latitude, longitude);
            if (city) localStorage.setItem(CITY_KEY, city);
            if (area) localStorage.setItem(AREA_KEY, area);

            sendPing({
                kioskUuid: getOrCreateKioskUuid(),
                coordinates,
                city: city || null,
                area: area || null,
                event: 'app_open'
            });
        },
        () => {}
    );
};

export const pingKioskLogin = (clientMobile, clientName) => {
    const kioskUuid = localStorage.getItem(KIOSK_UUID_KEY);
    const coordinates = localStorage.getItem(COORDS_KEY);
    if (!kioskUuid && !coordinates) return;
    sendPing({
        kioskUuid: kioskUuid || null,
        coordinates: coordinates || null,
        city: localStorage.getItem(CITY_KEY) || null,
        area: localStorage.getItem(AREA_KEY) || null,
        lastClientMobile: clientMobile || null,
        lastClientName: clientName || null,
        event: 'client_login'
    });
};
